import { brandLogoKey, brandNameLogoKey } from '../../config/constants';
import { useAppSelector } from '../../redux/hooks';
import LoadingThreeDots from './LoadingThreeDots';

type ILogoProps = {
  size?: number;
  isMiniWeb?: boolean;
};

function Logo({ size = 56, isMiniWeb = false }: ILogoProps) {
  const brandLogo = isMiniWeb
    ? localStorage.getItem(brandNameLogoKey)
    : localStorage.getItem(brandLogoKey);

  const getPublicDetailsLoading = useAppSelector((state) => state.miniweb.getPublicDetailsLoading);
  const loading = useAppSelector((state) => state.coach.getBrandConfigurationsLoading);

  const loadingLogo = isMiniWeb ? getPublicDetailsLoading : loading;

  if (loadingLogo) {
    return <LoadingThreeDots />;
  }
  // Render the image with default properties if `isMiniWeb` is true
  if (!loadingLogo && brandLogo) {
    return (
      <img
        src={brandLogo}
        alt="logo"
        height={!isMiniWeb ? size : undefined}
        width={!isMiniWeb ? size : undefined}
      />
    );
  }
  return <img src="/assets/icons/logo.svg" alt="logo" height={size} width={size} />;
}

export default Logo;
